"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (portNumber) => {
    portNumber = Number(portNumber);
    if (isNaN(portNumber) || portNumber < 3600) {
        return 'orap.exchange';
    }
    else {
        return 'orap.exchange.' + String(portNumber).substring(0, 2) + '_portRange';
    }
};
